/**
 * Open Box collection cards: live stock-gate against the Unlisted companion.
 *
 * Cards carry data-ob-handle (set by product-card.liquid in ob_mode). The V3
 * collection cron already prunes members whose open-box stock hit zero, so this
 * only covers the window between cron runs. Live truth comes from Shopify's own
 * /products/{handle}.js — same origin, resolves for Unlisted products via direct
 * handle (same pattern as used-banner.js).
 *
 * Unlike the PDP banner this fails OPEN: on a fetch error we leave the card
 * alone rather than blanking chunks of the grid — the companion PDP shows the
 * real availability either way. Only a definitive "no variant available"
 * answer hides a card.
 *
 * Facets, load-more and infinite scroll re-render the grid via innerHTML swaps,
 * so a MutationObserver re-gates new cards; the per-handle promise cache keeps
 * that from re-fetching anything.
 */
(function () {
  var stockByHandle = {}; // handle -> Promise<boolean|null>, null = unknown (fail open)

  function companionInStock(handle) {
    if (!stockByHandle[handle]) {
      stockByHandle[handle] = fetch('/products/' + handle + '.js')
        .then(function (res) { return res.ok ? res.json() : null; })
        .then(function (product) {
          if (!product) return null;
          return (product.variants || []).some(function (v) { return v.available; });
        })
        .catch(function () { return null; });
    }
    return stockByHandle[handle];
  }

  function gateCards(root) {
    (root || document).querySelectorAll('[data-ob-handle]').forEach(function (card) {
      companionInStock(card.getAttribute('data-ob-handle')).then(function (inStock) {
        if (inStock === false) {
          var item = card.closest('li') || card;
          item.style.display = 'none';
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    gateCards(document);

    var container = document.getElementById('ProductGridContainer');
    if (container && 'MutationObserver' in window) {
      new MutationObserver(function () {
        gateCards(container);
      }).observe(container, { childList: true, subtree: true });
    }
  });
})();
